import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";

export default function* financialStatementLock(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.PAGE_FINANCIAL_STATEMENT_LOCK_REQUEST
    });

    const res = yield call(Http.post, `financial-statements/close`, {
      ...action.payload
    });

    yield put({
      type: Constants.PAGE_FINANCIAL_STATEMENT_LOCK_SUCCESS
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, res?.data?.data);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.PAGE_FINANCIAL_STATEMENT_LOCK_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchFinancialStatementLock() {
  yield takeEvery(Constants.PAGE_FINANCIAL_STATEMENT_LOCK_START, financialStatementLock);
}
